import home from "./home/index.js";
import news from "./news/index.js";
import propertyDetail from "./property/detail.js";
import propertyIndex from "./property/index.js";
import column from "./column/index.js";
import staff from "./staff/index.js";
import searchSchool from "./search/school.js";
import searchArea from "./search/area.js";
import searchStation from "./search/station.js";
import company from "./company/index.js";
import sell from "./sell/index.js";
import campaign_events from "./campaign_events/index.js";
import flowOfBuying from "./flow_of_buying/index.js";
import flowOfSelling from "./flow_of_selling/index.js";
const pages = () => {
    home();
    news();
    propertyDetail();
    propertyIndex();
    column();
    staff();
    searchSchool();
    searchArea();
    searchStation();
    company();
    sell();
    campaign_events();
    flowOfBuying();
    flowOfSelling();
};

export default pages;
